<span class="font-weight-bold mr-1">Data Version: </span>
<span> {{ getDataVersionDisplay(route?.historicalDataVersion) }}</span>
